import React, { PropsWithChildren, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import { Token } from '../../model/Model';
import { getProfile } from '../../service/storage';
import { useParams } from 'react-router';
import { CheckinForm } from '../../service/checkin-flow';

export type VisitorFormProps = {
    onSubmit: (profile: CheckinForm) => void;
    readonly: boolean;
}

export const VisitorForm = ({
                                onSubmit,
                                readonly,
                                children,
                            }: PropsWithChildren<VisitorFormProps>) => {

    const {token} = useParams<Token>();
    const methods = useForm<CheckinForm>();
    const { register, handleSubmit, errors, setValue } = methods;

    useEffect(() => {
        if (token && location) {
            const params = new URLSearchParams(location.search);
            const l = params.get('l');
            const loadedProfile = getProfile(token);
            const profile = loadedProfile?.profile;
            if (profile && (profile?.rememberMe || l === '1')) {
                setValue('name', profile.name);
                setValue('company', profile.company);
                setValue('phone', profile.phone);
                setValue('rememberMe', profile.rememberMe);
                setValue('declaration', '');
            }
        }
    }, [token, location]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group controlId='fromNameGroup'>
                    <Form.Label>Full Name</Form.Label>
                    <Form.Control ref={register({
                        required: true,
                        minLength: 3,
                        maxLength: 100,
                        pattern: /^([a-zA-Z_\-']+\s[a-zA-Z_\-']+\s?[a-zA-Z_\-']+?)\s?$/i,
                    })}
                                  name='name' type='text' placeholder='E.g. John Smith' autoComplete='name'
                                  isInvalid={!!errors.name} readOnly={readonly} />
                    <Form.Control.Feedback type={'invalid'}>Full name required, eg. John Smith</Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId='formCompanyGroup'>
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control ref={register({ required: true, minLength: 3, maxLength: 100 })}
                                  name='company' type='text' placeholder='Company' autoComplete='organization-title'
                                  isInvalid={!!errors.company} readOnly={readonly} />
                    <Form.Control.Feedback type={'invalid'}>Company name required, i.e. Pegasus</Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId='formPhoneGroup'>
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                        ref={register({ required: true, minLength: 10, maxLength: 20, pattern: /^\+?[0-9]+\s?$/i })}
                        name='phone' type='tel' placeholder='Phone Number' autoComplete='tel'
                        isInvalid={!!errors.phone} readOnly={readonly} />
                    <Form.Control.Feedback type={'invalid'}>Phone number required, i.e.
                        0438555555</Form.Control.Feedback>
                </Form.Group>

                {children}

            </Form>
        </FormProvider>
    );
};
